/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Completed from './Completed/index'
import Failed from './Failed/index'
import InProgress from './InProgress/index'
import No from './No/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings/Content/Job/Content/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let jobStatusValueData = fromData.useDataValue({ viewPath,
context: 'job',
path: 'status',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: jobStatusValueData,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InProgress'}>
<InProgress
  viewPath={`${viewPath}/InProgress`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Completed'}>
<Completed
  viewPath={`${viewPath}/Completed`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Failed'}>
<Failed
  viewPath={`${viewPath}/Failed`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}